import { useTranslation } from "react-i18next";
import { PositionImage } from "../../../../interfaces";
import Attachments from "../../Attachments";
import {
  formatDateAndTime,
  getFileNameWithoutFolderName,
  getFileSizeInMb,
} from "../../../../utils";
import { DECLINE_POSITION_IMAGE } from "../../../../constant/ViewOrderConstant";

/**
 * This component is used to return card of declined position image
 * @param param0 position image details , created At and updated by details
 */
const UpdatedDeclinedLogs = ({
  positionImage,
  createdAt,
  updatedBy,
}: {
  positionImage: PositionImage;
  createdAt?: string;
  updatedBy?: string;
}) => {
  const { t } = useTranslation();
  return (
    <div className="card-auto p-24 my-10 row row-column gap-8">
      {createdAt && (
        <div>{formatDateAndTime(createdAt, "DD.MM.YYYY HH:mm:ss")}</div>
      )}
      <div>
        {updatedBy} <strong>{t("declined")}</strong> {t("printdata")}
      </div>
      {positionImage && (
        <div className="overflow-wrap-break-word">
          {getFileNameWithoutFolderName(positionImage.key)} (
          {positionImage.size && getFileSizeInMb(positionImage.size)}
          MB)
        </div>
      )}
      {positionImage.rejectedReason && (
        <div>
          {positionImage.rejectedReason.split(" ").map((reason) => (
            <div>
              {" "}
              {`- ${t(
                DECLINE_POSITION_IMAGE.find((val) => val.key === reason)
                  ?.value ?? "",
              )}`}{" "}
            </div>
          ))}
        </div>
      )}
      {positionImage.rejectedDescription && (
        <div>
          <div>{t("note")}:</div>
          <div className="word-break-break-all white-space-pre-wrap">
            {positionImage.rejectedDescription}
          </div>
        </div>
      )}
      {positionImage.files && positionImage.files.length > 0 && (
        <div>
          <div>{t("file")}:</div>
          <Attachments files={positionImage.files || []} />
        </div>
      )}
    </div>
  );
};

export default UpdatedDeclinedLogs;
